import React from 'react';
import ReactDOM from 'react-dom';

import Search from './Search';

const searchContainer = document.querySelector('[data-search-page]');
if (searchContainer) {
    ReactDOM.render(
        <Search {...searchContainer.dataset} />, // eslint-disable-line
        searchContainer,
    );
}
